module.exports={
	"Form": "FundEditManifest",
	"Scope": "Fund-Edit",
	"Descriptors":
	{
		"FundDetails.Name":
		{
			"Name": "Name",
			"Hash": "Fund-Edit-Name",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "1",
				"Width": 6,
				"Section": "Fund-Edit-Identity",
				"Group": "Fund-Edit-Identity"
			}
		},
		"FundDetails.Hash":
		{
			"Name": "Hash",
			"Hash": "Fund-Edit-Hash",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "2",
				"Width": 4,
				"Section": "Fund-Edit-Details",
				"Group": "Fund-Edit-Details"
			}
		},
		"FundDetails.Description":
		{
			"Name": "Description",
			"Hash": "Fund-Edit-Description",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "TextArea",
				"Row": "3",
				"Width": 12,
				"Section": "Fund-Edit-Details",
				"Group": "Fund-Edit-Details"
			}
		},
		"FundDetails.OriginalBalance":
		{
			"Name": "Original Balance",
			"Hash": "Fund-Edit-OriginalBalance",
			"DataType": "Number",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "4",
				"Width": 4,
				"Section": "Fund-Edit-Details",
				"Group": "Fund-Edit-Details"
			}
		},
		"FundDetails.TotalCommitted":
		{
			"Name": "Total Committed",
			"Hash": "Fund-Edit-TotalCommitted",
			"DataType": "Number",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "4",
				"Width": 4,
				"Section": "Fund-Edit-Details",
				"Group": "Fund-Edit-Details"
			}
		},
		"FundDetails.CommittedBalance":
		{
			"Name": "Committed Balance",
			"Hash": "Fund-Edit-CommittedBalance",
			"DataType": "Number",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "4",
				"Width": 4,
				"Section": "Fund-Edit-Details",
				"Group": "Fund-Edit-Details"
			}
		},
		"FundDetails.Balance":
		{
			"Name": "Balance",
			"Hash": "Fund-Edit-Balance",
			"DataType": "Number",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "5",
				"Width": 4,
				"Section": "Fund-Edit-Details",
				"Group": "Fund-Edit-Details"
			}
		},
		"FundDetails.TotalPendingCharge":
		{
			"Name": "Total Pending Charge",
			"Hash": "Fund-Edit-TotalPendingCharge",
			"DataType": "Number",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "5",
				"Width": 4,
				"Section": "Fund-Edit-Details",
				"Group": "Fund-Edit-Details"
			}
		},
		"FundDetails.ExternalAccountID":
		{
			"Name": "External Account ID",
			"Hash": "Fund-Edit-ExternalAccountID",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "5",
				"Width": 4,
				"Section": "Fund-Edit-Details",
				"Group": "Fund-Edit-Details"
			}
		},
		"FundDetails.CostCenter":
		{
			"Name": "Cost Center",
			"Hash": "Fund-Edit-CostCenter",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "6",
				"Width": 4,
				"Section": "Fund-Edit-Details",
				"Group": "Fund-Edit-Details"
			}
		},
		"FundDetails.Active":
		{
			"Name": "Active",
			"Hash": "Fund-Edit-Active",
			"DataType": "Boolean",
			"PictForm":
			{
				"InputType": "Boolean",
				"Row": "6",
				"Width": 3,
				"Section": "Fund-Edit-Details",
				"Group": "Fund-Edit-Details"
			}
		},
		"FundDetails.IDFund":
		{
			"Name": "IDFund",
			"Hash": "Fund-Edit-IDFund",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "7",
				"Width": 4,
				"Section": "Fund-Edit-DataAudit",
				"Group": "Fund-Edit-DataAudit"
			}
		},
		"FundDetails.GUIDFund":
		{
			"Name": "GUIDFund",
			"Hash": "Fund-Edit-GUIDFund",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "7",
				"Width": 4,
				"Section": "Fund-Edit-DataAudit",
				"Group": "Fund-Edit-DataAudit"
			}
		},
		"FundDetails.CreateDate":
		{
			"Name": "Create Date",
			"Hash": "Fund-Edit-CreateDate",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "7",
				"Width": 4,
				"Section": "Fund-Edit-DataAudit",
				"Group": "Fund-Edit-DataAudit"
			}
		},
		"FundDetails.CreatingIDUser":
		{
			"Name": "Creating IDUser",
			"Hash": "Fund-Edit-CreatingIDUser",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "8",
				"Width": 4,
				"Section": "Fund-Edit-DataAudit",
				"Group": "Fund-Edit-DataAudit"
			}
		},
		"FundDetails.UpdateDate":
		{
			"Name": "Update Date",
			"Hash": "Fund-Edit-UpdateDate",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "8",
				"Width": 4,
				"Section": "Fund-Edit-DataAudit",
				"Group": "Fund-Edit-DataAudit"
			}
		},
		"FundDetails.UpdatingIDUser":
		{
			"Name": "Updating IDUser",
			"Hash": "Fund-Edit-UpdatingIDUser",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "8",
				"Width": 4,
				"Section": "Fund-Edit-DataAudit",
				"Group": "Fund-Edit-DataAudit"
			}
		}
	},
	"Sections":
	[
		{
			"Name": "Identity",
			"Hash": "Fund-Edit-Identity",
			"Solvers": [],
			"ShowTitle": true,
			"Groups":
			[
				{
					"Name": "Identity",
					"Hash": "Fund-Edit-Identity",
					"Rows": [],
					"RecordSetSolvers": [],
					"ShowTitle": false
				}
			]
		},
		{
			"Name": "Details",
			"Hash": "Fund-Edit-Details",
			"Solvers": [],
			"ShowTitle": true,
			"Groups":
			[
				{
					"Name": "Details",
					"Hash": "Fund-Edit-Details",
					"Rows": [],
					"RecordSetSolvers": [],
					"ShowTitle": false
				}
			]
		},
		{
			"Name": "Data Audit",
			"Hash": "Fund-Edit-DataAudit",
			"Solvers": [],
			"ShowTitle": true,
			"Groups":
			[
				{
					"Name": "Data Audit",
					"Hash": "Fund-Edit-DataAudit",
					"Rows": [],
					"RecordSetSolvers": [],
					"ShowTitle": false
				}
			]
		}
	]
}
